/**
 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
 * @returns {object} Meta Object
 */
export function getPageMeta() {

	let data = {};
	let metaEl = document.querySelector('[fs-prop="analytics"]');
	let attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category',
		'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title',
		'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name',
		'page-attribute', 'testScorestripPosition'
	];

	/**
	 *  to enforce html semantic, we use dashes for property names.
	 *  We need to do the dashes replacement with underscore since
	 *  analytic script uses underscore in the properties
	 */
	for (var i = 0, l = attributes.length; i < l; i++) {
		let attr = attributes[i];
		let val = metaEl.getAttribute(attr);

		if (val != null) {
			attr = (attr.indexOf('-') >= 0) ? attr.replace(/-/g, '_') : attr;
			data[attr] = val.trim();
		}
	}

	return data;
}



// WEBPACK FOOTER //
// ./assets/components/analytics/utils.js